import { createContext, useContext } from 'react';

const PageBannerContext = createContext({ renderBanner: () => null });

export const usePageBannerContext = () => useContext(PageBannerContext);

export default PageBannerContext;
